"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CutScene = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var c = (0, BemBuilder_1.default)("cutscene");
var cutsceneLines = ["Get ready to create", "something great..."];
var CutScene = function (_a) {
    var onComplete = _a.onComplete, status = _a.status;
    (0, react_1.useEffect)(function () {
        var timeout = setTimeout(function () {
            onComplete();
        }, 3300);
        return function () {
            clearTimeout(timeout);
        };
    }, []);
    return (react_1.default.createElement("div", { className: c("outer") },
        react_1.default.createElement("div", { className: (0, classnames_1.default)(c("logo-wrapper"), c("logo-wrapper", status)) },
            react_1.default.createElement("div", { className: c("logo") },
                react_1.default.createElement("svg", { width: "84", height: "84", fill: "none", viewBox: "0 0 84 84", "aria-label": "Qwilr" },
                    react_1.default.createElement("path", { fill: "#fff", d: "M42 84c23.196 0 42-18.804 42-42S65.196 0 42 0 0 18.804 0 42s18.804 42 42 42Z" }),
                    react_1.default.createElement("path", { fill: "#00A99D", d: "m22.712 52.51 4.867 7.414c.189.292.45.533.76.7a2.138 2.138 0 0 0 2.027 0c.31-.167.571-.408.76-.7l10.868-17.218-8.083-12.836-11.265 18.354c-.4.65-.607 1.395-.596 2.152.012.757.241 1.496.662 2.134Z" }),
                    react_1.default.createElement("path", { fill: "#EF445A", d: "M61.353 48.224 50.088 29.87l-8.094 12.857 10.88 17.218c.188.292.45.533.76.7a2.138 2.138 0 0 0 2.026 0 2.07 2.07 0 0 0 .76-.7l4.867-7.414c.422-.641.65-1.384.663-2.145a4.008 4.008 0 0 0-.597-2.162Z" }),
                    react_1.default.createElement("path", { fill: "#01445A", d: "m46.994 24.824-3.216-4.96a2.067 2.067 0 0 0-.76-.707 2.138 2.138 0 0 0-2.036 0 2.068 2.068 0 0 0-.76.706l-3.216 4.972-3.094 5.035 8.083 12.857 8.093-12.803-3.094-5.1Z" })))),
        react_1.default.createElement(kaleidoscope_1.Heading, { strong: true, level: "2", element: "h1", className: c("heading"), "aria-label": cutsceneLines.join(" ") }, cutsceneLines.map(function (line, lineIndex) { return (react_1.default.createElement("div", { className: c("heading-line"), key: line, style: {
                "--line-delay": "".concat(lineIndex * 0.6, "s"),
            } }, line.split("").map(function (letter, index) { return (react_1.default.createElement("span", { key: "".concat(letter, "-").concat(index), className: (0, classnames_1.default)(c("heading-letter"), c("heading-letter", status)), style: {
                "--delay": "".concat(index * 0.035, "s"),
            } }, letter)); }))); }))));
};
exports.CutScene = CutScene;
